import Tooltip from '@mui/material/Tooltip';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import PropTypes from 'prop-types';
import React from 'react';
import dayjs from '../../config/dayjs';
import { isHoliday } from '../../helpers/date-to-pay-restrictions';
import { useUpcomingHolidayDates } from '../../hooks/useUpcomingHolidays';

const DatePickerTooltip = ({ day, pickersDayProps, minDate, maxDate, className }) => {
  const holidayDates = useUpcomingHolidayDates();

  if (pickersDayProps.disabled) {
    let reason = 'Fecha no disponible';
    if (day.day() === 0 || day.day() === 6) {
      reason = 'No se pueden seleccionar fines de semana';
    } else if (isHoliday(day, holidayDates)) {
      reason = 'Este día es feriado';
    } else if (minDate && day.isBefore(minDate, 'day')) {
      reason = 'Fecha anterior al mínimo permitido';
    } else if (maxDate && day.isAfter(maxDate, 'day')) {
      reason = 'Fecha posterior al máximo permitido';
    }
    return (
      <Tooltip title={reason}>
        <span>
          <PickersDay {...pickersDayProps} className={className} />
        </span>
      </Tooltip>
    );
  }
  return <PickersDay {...pickersDayProps} className={className} />;
};

DatePickerTooltip.propTypes = {
  day: PropTypes.instanceOf(dayjs).isRequired,
  pickersDayProps: PropTypes.shape({
    disabled: PropTypes.bool,
  }).isRequired,
  minDate: PropTypes.instanceOf(dayjs),
  maxDate: PropTypes.instanceOf(dayjs),
  className: PropTypes.string,
};

DatePickerTooltip.defaultProps = {
  minDate: null,
  maxDate: null,
  className: '',
};

export default DatePickerTooltip;
